var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2513_95747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3857 10.2891L27.7562 3.76735C27.5563 2.96608 26.8361 2.4043 26.0096 2.4043H4.00811C3.18163 2.4043 2.46139 2.96608 2.25973 3.76735L0.630189 10.2891C0.612183 10.3593 0.60318 10.4332 0.60318 10.507C0.60318 12.9882 2.52081 15.0085 4.87959 15.0085C6.24985 15.0085 7.47245 14.326 8.25571 13.2673C9.03897 14.326 10.2616 15.0085 11.6318 15.0085C13.0021 15.0085 14.2247 14.326 15.0079 13.2673C15.7912 14.326 17.012 15.0085 18.3841 15.0085C19.7561 15.0085 20.9769 14.326 21.7602 13.2673C22.5434 14.326 23.7642 15.0085 25.1363 15.0085C27.4951 15.0085 29.4127 12.9882 29.4127 10.507C29.4127 10.4332 29.4037 10.3593 29.3857 10.2891Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1364 16.8097C23.9102 16.8097 22.7452 16.4352 21.7603 15.751C19.7904 17.1212 16.9779 17.1212 15.0081 15.751C13.0382 17.1212 10.2257 17.1212 8.25583 15.751C7.27091 16.4352 6.10592 16.8097 4.87972 16.8097C3.99563 16.8097 3.16195 16.6027 2.4039 16.2497V25.8127C2.4039 26.8066 3.21057 27.6133 4.2045 27.6133H11.4069V20.4109H18.6093V27.6133H25.8116C26.8056 27.6133 27.6122 26.8066 27.6122 25.8127V16.2497C26.8542 16.6027 26.0205 16.8097 25.1364 16.8097Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.368c8830955df58baf8dda1449c8091e.svg";
export { ForwardRef as ReactComponent };